// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Header from './components/Header';
// import Menu from './components/Menu';
// import Footer from './components/Footer';
// import DashboardPage from './pages/Dashboard';
// import ClaimsListPage from './pages/ClaimsListPage';
// import Logout from './pages/Logout';
// import { useAuth } from "react-oidc-context";
// import { cognitoAuthConfig } from "./config/authConfig";
// import TestAuthSuccess from './pages/TestAuthSuccess';


// function AppWrapper() {
//   const auth = useAuth();

//   const signOutRedirect = () => {
//     const clientId = cognitoAuthConfig.client_id;
//     const logoutUri = cognitoAuthConfig.logoutUri; // Update for your environment
//     const cognitoDomain = cognitoAuthConfig.cognitoDomain;
//     window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
//   };

//   React.useEffect(() => {
//     console.log("Auth state changed:", auth);
//     if (!auth.isLoading && !auth.isAuthenticated && !auth.error) {
//       auth.signinRedirect();
//     }
//   }, [auth.isLoading, auth.isAuthenticated, auth.error, auth]);

//   if (auth.isLoading) {
//     return <div>Loading...</div>;
//   }

//   if (auth.error) {
//     console.error("Auth error:", auth.error);
//     return <div>Encountering error... {auth.error.message}</div>;
//   }

//   // Only render app content if authenticated
//   return auth.isAuthenticated ? (
//     <>
//       <Header />
//       <Menu />
//       <Routes>
//         <Route path="/dashboard" element={<DashboardPage />} />
//         <Route path="/claims" element={<ClaimsListPage />} />
//         <Route path="/logout" element={<Logout />} />
//         <Route path="/test-auth-success" element={<TestAuthSuccess />} />
//         {/* Add more routes as needed */}
//       </Routes>
//       <Footer />
//       <button onClick={signOutRedirect}>Sign out</button>
//     </>
//   ) : null;
// }

// function App() {
//   return (
//     <Router>
//       <AppWrapper />
//     </Router>
//   );
// }

// export default App;

import React from 'react';
import SmartClaimsAssistant from './pages/SmartClaimsAssistant';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Menu from './components/Menu';
import Footer from './components/Footer';
import DashboardPage from './pages/Dashboard';
import ClaimsListPage from './pages/ClaimsListPage';
import Logout from './pages/Logout';
import TestAuthSuccess from './pages/TestAuthSuccess';

function AppWrapper() {
  return (
    <>
      <Header />
      <Menu />
      <Routes>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/claims" element={<ClaimsListPage />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/test-auth-success" element={<TestAuthSuccess />} />
        <Route path="/smart-claims" element={<SmartClaimsAssistant />} /> 
        {/* Add more routes as needed */}
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;